<template>
  <div class="aviasales">
    <app-cells position="between">
      <div>
        <h1 class="title">Aviasales</h1>
      </div>
    </app-cells>
    <flight-booking-flow :can-select="isGeneralManager" />
  </div>
</template>

<script>
import FlightBookingFlow from '@/components/flights/FlightBookingFlow.vue'

export default {
  name: 'FlightsAviasales',
  components: { FlightBookingFlow },
  computed: {
    isGeneralManager() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager')
    }
  }
}
</script>
